import React from 'react';
import template from 'template/sign_up/form/sign_up_form';
import SignUpModel from "../model/sign_up_model";
import SignUpRepository from "../repository/sign_up_repository";
import BaseFormComponent from "../../../common/component/base_form";

export default class SignUpFormComponent extends BaseFormComponent {

    initRepository() {
        this.repository = new SignUpRepository();
    }

    makeNewModel() {
        let model = new SignUpModel();
        model.country_id = this.props.defaultCountry;

        return model;
    }

    onVerify(token) {
        this.model.recaptcha_token = token;
    }

    onChangeLogin(login) {
        this.model.login = login;
    }

    onChangeCountry(event) {
        this.model.country_id = event.target.value;
    }

    onSave(model) {
        location.href = model.redirect_url;
    }

    render() {
        return template.bind(this)();
    }

}